import { Box } from '@chakra-ui/react';
import AdBanner from "../../../assets/banner.png";
export const AdBannerComponent = () => {
    return (
        <Box backgroundImage={AdBanner} backgroundRepeat={'no-repeat'} backgroundSize={"cover"} backgroundColor={"black"} height={"132px"} width={"100%"}/>
    );
};